export default function ServicesHero() {
  return (
    <section className="relative pt-36 pb-20 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1c1edd90407dbc4750c2d321e7e62a47.jpg"
          alt="AWWAL Services"
          className="w-full h-full object-cover object-top opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#080808]/80 to-[#080808]" />
      </div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="inline-flex items-center gap-2 px-4 py-2 border border-[#00ff88]/30 rounded-sm bg-[#00ff88]/5 mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-[#00ff88] animate-pulse" />
          <span className="text-[#00ff88] text-xs tracking-[0.3em] uppercase font-semibold font-inter">What We Offer</span>
        </div>
        <h1 className="text-5xl lg:text-7xl font-black text-white tracking-tight leading-none mb-6 max-w-2xl font-syne">
          Services Built<br />for <span className="text-[#00ff88]">Champions.</span>
        </h1>
        <p className="text-white/45 text-lg max-w-xl leading-relaxed font-inter">
          From ground-up game development to enterprise-grade guild infrastructure, our services are engineered to deliver results at every scale.
        </p>
      </div>
    </section>
  );
}
